import { replaceFinalTaggedSections } from "@builder/assist/ui/helpers/tagHelpers";
import { Message, TextStreamPart } from "ai";
import "./messages.scss";
import { AnimatedThreeDots } from "@builder/components/onboard/components/smallComponents/AnimatedThreeDots";
import { randomThinkingTexts, stepTextToShow, toolCallToText } from "../../helpers/wordingHelpers";
import { useMemo } from "react";

export const UserMessage = ({ message }: { message: Message }) => {
    const attachments = (message as any).experimental_attachments as { url: string }[] | undefined;

    return (
        <div className="user-message">
            {attachments && attachments.length > 0 && (
                <div className="message-attachments">
                    {attachments.map(({ url }, idx) => (
                        <img key={idx} src={url} alt={`attachment-${idx}`} className="message-attachment-image" />
                    ))}
                </div>
            )}
            <div className="message-text-content">{replaceFinalTaggedSections(message.content)}</div>
        </div>
    );
};

export const AssistantMessage = ({ message, steps }: { message: Message; steps?: TextStreamPart<any>[] }) => {
    const stepsToIgnore = ["text-delta", "tool-result"];
    const stepsToShow = steps?.filter(step => !stepsToIgnore.includes(step.type)).slice(-4); // show max 4 steps

    return (
        <div className="assistant-message">
            <div className="assist-title">
                <img src={"/assist-icon.png"} alt="assistant" />
                <span>Assist</span>
            </div>
            <div className="steps-container">
                {stepsToShow &&
                    stepsToShow.map((step, index) => (
                        <StepMessage step={step} key={message.id + index} isActive={!message.content && index === stepsToShow.length - 1} />
                    ))}
            </div>
            <div className="message-text-content">{replaceFinalTaggedSections(message.content)}</div>
        </div>
    );
};

export const StepMessage = ({ step, isActive }: { step: TextStreamPart<any>; isActive: boolean }) => {
    const stepText: stepTextToShow = useMemo(() => {
        console.log("%cSTEP:", "color: green; font-weight: bold;", step);
        let text = randomThinkingTexts[Math.floor(Math.random() * randomThinkingTexts.length)];

        if (step.type === "tool-call") {
            const translator = toolCallToText[(step as any).toolName as keyof typeof toolCallToText];
            if (translator) {
                text = translator(step);
            }
        }

        return text;
    }, [step]);

    return (
        <p className="step-message">
            {isActive ? stepText.present : stepText.past}
            <span className="step-message-dots">{isActive && <AnimatedThreeDots numDots={5} numToFreeze={4} />}</span>
        </p>
    );
};
